function parseDate(obj?: any) {
  if (!obj?.date || !obj.timezone_type || !obj.timezone) {
    return;
  }

  return new Date(obj.date).getTime();
}

export default parseDate;